import moment from 'moment';
import ReactSelectFormatter from "./ReactSelectFormatter";

import {DATE_TIME_FORMAT} from '../components/helpers/DateHelper';
import FormDataFormatter from "./FormDataFormatter";

class ServiceFormSerializer {
    static serialize(service, userId) {
        let request = {
            id: service.id,
            startDate: this.getUnixStamp(service.startDate),
            endDate: this.getUnixStamp(service.endDate),
            isStatistics: service.isStatisticAllowed || false,
            heading: service.heading,
            type: service.type,
            creatorId: userId.toString(),
            isCommentsAllowed: service.isCommentsAllowed || false,
            images: service.images,
            files: service.files,
            defaultImageIds: service.defaultImageIds,
            defaultFileIds: service.defaultFileIds,
            videoLink: service.youtubeId,
            vimeoId: service.vimeoId,
            description: service.description
        };

        if (service.contactPersonId !== undefined) {
            request.contactPersonId = service.contactPersonId;
        }

        if (service.categoryIds !== undefined) {
            request.categoriesIds = service.categoryIds;
        }

        if (service.amount !== undefined) {
            request.priceAmount = service.amount;
            request.currencyId = service.currencyId;
            request.priceTypeId = service.priceTypeId
        }

        return FormDataFormatter.getFormData({...request});
    }

    static formatResponseFiles(service) {
        let formattedService = {...service};

        if (formattedService.images instanceof Object) {
            if (!(formattedService.images instanceof Array)) {
                formattedService.images = Object.values(formattedService.images);
            }

            formattedService.defaultImages = formattedService.images;
            formattedService.defaultImageIds = formattedService.defaultImages.map(image => image.id);
        }
        else {
            formattedService.images = formattedService.defaultImages = formattedService.defaultImageIds = [];
        }

        if (formattedService.files instanceof Object) {
            if (!(formattedService.files instanceof Array)) {
                formattedService.files = Object.values(formattedService.files);
            }

            formattedService.defaultFiles = formattedService.files;
            formattedService.defaultFileIds = formattedService.defaultFiles.map(file => file.id);
        }
        else {
            formattedService.files = formattedService.defaultFiles = formattedService.defaultFileIds = [];
        }

        return formattedService;
    }

    static unserialize(response) {
        let formattedService = this.formatResponseFiles(response);

        let data = {
            id: formattedService.id,
            description: formattedService.description,
            contactPersonId: formattedService.contactPerson ? formattedService.contactPerson.id : null,
            startDate: moment.unix(formattedService.startDate).format(DATE_TIME_FORMAT),
            endDate: moment.unix(formattedService.endDate).format(DATE_TIME_FORMAT),
            categoryIds: formattedService.categories.map(c => c.id) || [],
            heading: formattedService.heading,
            isStatisticAllowed: formattedService.isStatisticAllowed,
            isCommentsAllowed: formattedService.isCommentsAllowed || false,
            type: formattedService.wanted ? 'wanted' : 'offering',
            youtubeId: formattedService.videoLink,
            vimeoId: formattedService.vimeoId,
            referenceNumber: formattedService.link,
            images: [],
            defaultImages: formattedService.defaultImages,
            defaultImageIds: formattedService.defaultImageIds,
            files: [],
            defaultFiles: formattedService.defaultFiles,
            defaultFileIds: formattedService.defaultFileIds,
        };
        if (formattedService.price.length !== 0) {
            data.amount = formattedService.price.amount;
            data.currencyId = formattedService.price.currency.id;
            data.priceTypeId = formattedService.price.type.id;
        } else {
            data.currencyId = 1;
            data.priceTypeId = 3;
        }

        return data;
    }



    /**
     *
     * @param {string} dateString
     * @returns {number}
     */
    static getUnixStamp(dateString) {
        return moment(dateString, DATE_TIME_FORMAT).unix();
        // return DateHelper.getUnixTimestampByTimezone(dateObject);
    }
}

export default ServiceFormSerializer;


// WEBPACK FOOTER //
// ./web/src/services/ServiceFormSerializer.js